<template>
  <v-card
    color="grey lighten-2"
    width="300"
    style="margin: 0px auto"
    align="center"
    flat
  >
    <v-card-text>
      <v-row>
        <v-card
          class="d-flex justify-center px-5 mb-6"
          flat
          style="background: transparent"
          tile
        >
          <v-card
            class="pa-0"
            style="background: transparent"
            width="50"
            flat
          >
            <div style="height: 50px;width: 100%;background-color: #ffae00;text-align: center;border-radius: 5px">
              <v-btn
                tile
                icon
                style="border-radius: 10px;font-size: 40px;"
                width="40px"
                @click="subNum"
              >
                <v-icon
                  class="mt-2"
                  style="font-size: 20px"
                  color="white"
                >
                  mdi-backspace-outline
                </v-icon>
              </v-btn>
            </div>
          </v-card>
          <v-card
            class="pa-0 ps-1"
            flat
            style="background: transparent"
            width="262"
          >
            <div
              class="mb-0 mx-0 pt-1"
              style="height: 50px;width: 100%;background-color: #414141;text-align: center;border-radius: 5px"
            >
              <p
                class="ma-0 mt-3"
                style="font-size: 26px;color: #ffffff"
              >
                {{ (value && value.charAt(value.length - 1) === '.' ? $numberFormat(value) + '.0' : $numberFormat(value)) }}
              </p>
            </div>
          </v-card>
        </v-card>
      </v-row>
      <v-row
        no-gutters
        style="direction: ltr !important;width: 260px"
      >
        <v-col
          v-for="n in 9"
          :key="n"
          class="ma-1 align justify"
        >
          <v-btn
            color="primary"
            tile
            elevation="1"
            height="75px"
            width="75px"
            style="border-radius: 10px;font-size: 40px"
            @click="clickNum(n)"
          >
            {{ n }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        style="direction: ltr !important;width: 260px"
        class="pb-1 mt-0"
      >
        <v-col class="align justify ma-1">
          <v-btn
            color="primary"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="clickNum(0)"
          >
            0
          </v-btn>
        </v-col>
        <v-col class="align justify ma-1">
          <v-btn
            color="primary"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="clickNum(10)"
          >
            00
          </v-btn>
        </v-col>
        <v-col class="align justify ma-1">
          <v-btn
            color="primary"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="clickNum(100)"
          >
            000
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        style="direction: ltr !important;width: 260px"
        class="pb-1 mt-0"
      >
        <v-col class="align justify ma-1">
          <v-btn
            color="green"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="onSave"
          >
            <v-icon
              style="font-size: 45px"
            >
              mdi-check-outline
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="align justify ma-1">
          <v-btn
            color="primary"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="clickNum(200)"
          >
            .
          </v-btn>
        </v-col>
        <v-col class="align justify ma-1">
          <v-btn
            color="pink"
            tile
            elevation="1"
            height="70px"
            width="70px"
            style="border-radius: 10px;font-size: 40px"
            @click="cancel"
          >
            <v-icon
              style="font-size: 45px"
            >
              mdi-language-c
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Numpad',
  props: {
    input: {
      type: [String, Number],
      default: '0'
    },
    label: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  data () {
    return { value: '0', previousValue: '0' }
  },
  watch: {
    // When receives a new number through props update inner value
    input (val) {
      this.value = val.toString()
      this.previousValue = val.toString()
    }
    /* When inner value gets a new value, emits and event to parent
    value(val) {
      this.$emit('output', val)
    } */
  },
  mounted () {
    if (this.input) {
      this.value = this.input.toString()
      this.previousValue = this.input.toString()
    }
  },
  methods: {
    subNum () {
      if (this.value.length > 1) {
        this.value = this.value.slice(0, -1)
      } else {
        this.value = '0'
      }
    },
    clickNum (num) {
      var n = num
      if (this.value.toString().length > 15) return
      if (this.value === '0') { this.value = '' }
      if (num === 10) { n = '00' }
      if (num === 100) { n = '000' }
      if (num === 200) { n = '.' }
      if (this.value && this.value.charAt(0) === '0') {
        this.value = this.value + n.toString()
      } else {
        this.value = this.value + n.toString()
      }
      this.$emit('output', this.value)
    },
    clickClear () {
      this.value = '0'
    },
    clickDecimal () {
      if (this.value.includes('.')) return
      this.value = this.value + '.'
    },
    cancel () {
      this.clickClear()
      this.$emit('output', null)
    },
    onSave () {
      this.$emit('save', this.value)
      this.value = '0'
    }
  }
}
</script>

<style>
</style>
